"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentEasternProgrammingDateStr = exports.determineIfShowIsOnNow = exports.create2WeeksList = exports.chunkArray = void 0;
var _add = _interopRequireDefault(require("date-fns/add"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _sub = _interopRequireDefault(require("date-fns/sub"));
var _dateFnsTz = require("date-fns-tz");
var _helpers = require("./helpers");
const getCurrentEasternProgrammingDateStr = () => {
  const now = new Date();
  // get the current date string in EST/D time
  let estDateString = now.toLocaleString('en-US', {
    timeZone: "America/New_York"
  });
  let [date, time] = estDateString.split(',');
  // since the programming schedule runs from 6am to 6am,
  // if the time is after midnight but before 6am the schedule start date will be from the previous day
  const hourNumber = Number.parseInt(time.split(':')[0], 10);
  if (time.includes('AM') && (hourNumber < 6 || hourNumber === 12)) {
    estDateString = new Date((0, _sub.default)(now, {
      days: 1
    })).toLocaleString('en-US', {
      timeZone: "America/New_York"
    });
    const newDate = estDateString.split(',');
    date = newDate[0];
    time = newDate[1];
  }
  // break out the individual date and time parts
  const [month, day, year] = date.split('/');
  const [hms, modifier] = time.trim().split(' ');
  const [hours, minutes] = hms.split(':');
  const timeIn24HrStr = (0, _helpers.convert12to24)(`${hours}:${minutes} ${modifier}`);

  // create a date string to represent the first date for the schedule 
  return (0, _format.default)(new Date(`${year}-${month.length < 2 ? "0" + month : month}-${day.length < 2 ? "0" + day : day}T${timeIn24HrStr}:00`), 'yyyy-MM-dd');
};

/**
 * creates an array containing dates for 2 weeks
 * starting from todays date
 * 
 * dates have five attributes: 
 *      dayStr (string format EEE)
 *      monthStr (string format MMM) 
 *      dateStr (string format d)
 *      fullDateStr (string format yyyy-MM-dd)
 *      date (a date object)
 * 
 * @returns {Array} weeks
 */
exports.getCurrentEasternProgrammingDateStr = getCurrentEasternProgrammingDateStr;
const create2WeeksList = () => {
  const today = new Date(`${getCurrentEasternProgrammingDateStr()}T00:00:00`);
  let days = [];
  // create an array of dates for the next 2 weeks
  // starting from what today was determined to be
  for (let i = 0; i <= 13; ++i) {
    const newDay = (0, _add.default)(today, {
      days: i
    });
    days.push({
      dayStr: i === 0 ? "Today" : (0, _format.default)(newDay, "EEE"),
      monthStr: (0, _format.default)(newDay, "MMM"),
      dateStr: (0, _format.default)(newDay, 'd'),
      fullDateStr: (0, _format.default)(newDay, "yyyy-MM-dd"),
      date: newDay
    });
  }
  return days;
};

/**
 * 
 * @param {[]*} array 
 * @param {number} size 
 * @returns 
 */
exports.create2WeeksList = create2WeeksList;
const chunkArray = (array, size) => {
  // Validate the input
  if (!Array.isArray(array)) {
    throw new TypeError('First argument must be an array');
  }
  if (typeof size !== 'number' || size <= 0) {
    throw new TypeError('Second argument must be a positive number');
  }

  // Initialize the result array
  const result = [];

  // Loop through the array and create chunks
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
};

/**
 * Checks the current time against the airdate and length of a show
 * to determine if the show is currently on the air
 * 
 * @param {string} airdateStr - needs to be parseable by Date() method
 * @param {string} elementLength - format H:MM
 * @returns {boolean}
 */
exports.chunkArray = chunkArray;
const determineIfShowIsOnNow = (airdateStr, elementLength) => {
  const now = new Date();
  // we need to make sure the start times we compare to are relative to EST/D times not local times
  // adding the timezone offset will set the local time to what it would be at that EST/D time
  // since the offset can be -4 or -5 depending on daylight savings time we need
  // to figure out which one it is on the given date
  // 3600000 = 1000 * 60 * 60 convert to hours
  const ESTtimeZoneOffset = (0, _dateFnsTz.getTimezoneOffset)('America/New_York', new Date(airdateStr)) / 3600000;
  // use the timezone offset to get the correct local time for the airdate we are checking against
  const localAirdate = new Date(`${airdateStr}:00-0${ESTtimeZoneOffset * -1}:00`);
  // convert the element lentgh to minutes
  const [hours, mins] = elementLength.split(':');
  const minutes = Number.parseInt(hours, 10) * 60 + Number.parseInt(mins, 10);
  return now >= localAirdate && now <= (0, _add.default)(localAirdate, {
    minutes
  });
};
exports.determineIfShowIsOnNow = determineIfShowIsOnNow;